export const startServer = () => {
    console.log("starting server...")
    return "Starting Server... "
};
